<template>
  <ReviewBoosterTooltip
    :text="$t('message.reviewBooster.changeBlocked')"
    :disabled="!localValue.isBlocked"
  >
    <div class="tag-item" :class="tagStateClasses">
      <ReviewBoosterTagItemContent
        :max-characters="maxCharacters"
        :is-auto-assigned="localValue.isAutoAssigned"
        :name="tag.name"
        @click="isToggleEnabled ? tagClickHandler() : null"
      />

      <TagsManagerListSentimentSelector
        :read-only="!isToggleEnabled"
        :active="localValue.isActive"
        :sentiment="localValue.sentiment"
        :is-blocked="localValue.isBlocked"
        @change-sentiment="onChange(true, $event)"
        @clear-selection="onClearSelection(false, undefined)"
      />
    </div>
  </ReviewBoosterTooltip>
</template>

<script>
import TagsManagerListSentimentSelector from "@/components/Tags/TagsManagerListSentimentSelector.vue";
import ReviewBoosterTooltip from "./ReviewBoosterTooltip";
import ReviewBoosterTagItemContent from "./ReviewBoosterTagItemContent";
export default {
  name: "ReviewBoosterTagItem",
  components: {
    TagsManagerListSentimentSelector,
    ReviewBoosterTooltip,
    ReviewBoosterTagItemContent
  },
  model: {
    prop: "active"
  },
  props: {
    active: {
      type: Object,
      default: () => {
        return {
          isActive: false,
          sentiment: null,
          isAutoAssigned: false
        };
      }
    },
    tag: {
      type: Object,
      required: true
    },
    toggleEnabled: {
      type: Boolean,
      default: false
    },
    maxCharacters: {
      type: Number,
      default: 0
    },
    isProcessing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return { menu: false, isAuto: false, localValue: null };
  },
  computed: {
    tagStateClasses() {
      return {
        "is-active": this.localValue.isActive,
        "is-toggleable": this.isToggleEnabled,
        "is-processing": this.isProcessing,
        "is-blocked": this.localValue.isBlocked
      };
    },

    isToggleEnabled() {
      return this.toggleEnabled && !this.isProcessing;
    }
  },

  watch: {
    active: {
      handler(current) {
        this.localValue = current;
      },
      immediate: true
    },
    tag: {
      immediate: true,
      handler(current, last) {
        if (!current.hasOwnProperty("is_auto_categorized")) return;
        const isCurrentAutoCategorized = current.is_auto_categorized;
        if (
          (!last && isCurrentAutoCategorized) ||
          (last && isCurrentAutoCategorized !== last.is_auto_categorized)
        ) {
          this.isAuto = isCurrentAutoCategorized;
        }
      }
    }
  },

  methods: {
    tagClickHandler() {
      if (!this.localValue.isActive) {
        this.onChange(!this.localValue.isActive, this.localValue.sentiment);
        return;
      }
      this.onClearSelection();
    },
    changeAuto(current) {
      this.tag.is_auto_categorized = current;
      this.$emit("change-auto", this.tag);
    },
    onChange(isActive, sentiment = null) {
      this.$emit("change", { ...this.localValue, isActive, sentiment });
    },
    onClearSelection() {
      this.$emit("change", {
        ...this.localValue,
        isActive: false,
        sentiment: undefined
      });
    },
    onSentimentChange(event) {
      this.$emit("change-sentiment", event);
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-item {
  display: flex;
  align-items: center;
  background: $light-4;
  border-radius: $container-border-radius;
  margin: 0;
  height: 46px;

  &__content {
    padding: 0 $spacing * 2;
    display: flex;
    align-items: center;
  }

  &__name {
    @include font-size(14px);
    color: $dark-blue-3;
    font-weight: 500;
    text-overflow: ellipsis;
  }

  &.is-blocked {
    background: rgba($primary, 0.75) !important;

    ::v-deep .sentiment-dropdown {
      background: transparent;
    }
  }

  &.is-processing {
    opacity: 0.5;
  }

  &.is-active {
    background: $primary;

    ::v-deep.v-icon:before,
    ::v-deep.tag-content__name {
      color: $light;
    }
  }

  &.is-toggleable {
    cursor: pointer;
    user-select: none;
  }
}
</style>
